import Vue from 'vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck, faCheckCircle, faExclamationCircle, faFont, faAlignCenter, faAlignLeft, faAlignRight, faSquare, faCog, faSignOutAlt, faTimes, faSpinner, faFilePdf, faFileImage, faPhone, faEnvelope, faArrowAltCircleDown, faAngleDown, faList, faWrench, faUser, faUserCog, faUsers, faBuilding, faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import App from './App.vue'

// Bootstrap
Vue.use(BootstrapVue)
// FontAwesome
library.add(
  faCheck, faCheckCircle, faExclamationCircle, faFont, faAlignCenter, faAlignLeft, faAlignRight, faSquare,
  faCog, faSignOutAlt, faTimes, faSpinner, faFilePdf, faFileImage, faPhone, faEnvelope,
  faArrowAltCircleDown, faAngleDown, faList, faWrench, faUser, faUserCog, faUsers, faBuilding,
  faCaretDown, faCaretRight
)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

// Set global filters
Vue.filter('capitalize-first', function (value) {
  return value.length > 0 ? value.charAt(0).toUpperCase() + value.slice(1) : ''
})
Vue.filter('round-one-decimal', function (value) {
  value = parseFloat(value)
  return value.toFixed(1)
})
Vue.filter('round-two-decimals', function (value) {
  value = parseFloat(value)
  return value.toFixed(2)
})
Vue.filter('remove-trailing-zeros', function (value) {
  value = parseFloat(value)
  return value.toString()
})
Vue.filter('decimal-comma', function (value) {
  return value.replace('.', ',')
})

var mixin = {
  methods: {
    boolToText: function (val) {
      return val === true ? this.$t('yes') : this.$t('no')
    }
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  mixins: [mixin],
  render: h => h(App)
}).$mount('#app')
